import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Card, Container } from "@maeiz/ui";

export const NotFoundPage: React.FC = () => {
    const { t } = useTranslation();
    return (
        <Container>
            <Card padding="lg" className="mx-auto mt-10 max-w-lg space-y-3 text-center">
                <p className="font-display text-5xl font-bold text-secondary" aria-hidden>
                    404
                </p>
                <h1 className="font-display text-xl font-semibold text-neutral-dark dark:text-white">
                    {t("errors.notFound.title")}
                </h1>
                <p className="text-sm text-neutral-secondary">{t("errors.notFound.body")}</p>
                <Link
                    to="/"
                    className="inline-block pt-2 text-sm font-medium text-secondary hover:underline"
                >
                    {t("errors.notFound.back")}
                </Link>
            </Card>
        </Container>
    );
};
